import Campaign from './Campaign.js';
import enhance from './enhancer';

export default enhance(Campaign);
